import { useOrderStore as useOrderStoreCommon } from "common";

export const useOrderStore = () => useOrderStoreCommon(usePinia());
